import Gate from "@/pcm/plugins/authorization/Gate";
import User from "@/pcm/store/models/User";
import {useAuthentication} from "@/pcm/plugins/authentication/authenticationPlugin";
import {useBus} from "@/pcm/plugins/helper";

const bus = useBus();

export default {
    install: (app: any) => {
        Gate.prototype.after = (user: User) => user && user.hasPermissionTo('super_admin');

        const gate = new Gate(useAuthentication().user);

        app.config.globalProperties.$gate = window.gate = gate;

        bus.on('setGateUser', (user: User) => {
            gate.setUser(user);
            bus.emit('reloadGateChecks');
        });
    }
}
